import React from 'react';
import { metrics, secondaryMetrics } from '../data/profile';
import { Counter } from './Counter';
import { Reveal } from './Reveal';
export function MetricsBar() {
  return <section aria-label="Scale of responsibility" className="w-full border-b border-line bg-white" data-id="element-379" data-mp="19nqihnqdbevk">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-380" data-mp="14x0h0ll2bw65">
        <dl className="grid grid-cols-1 gap-x-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-381" data-mp="14vflotqxc978">
          {metrics.map((metric, index) => <Reveal key={metric.label} delay={index * 0.07} data-id="element-382" data-mp="1iq86a6lo8fko" data-mpi={index}>
              <div className="group flex h-full flex-col justify-between border-t-2 border-line py-9 transition-colors duration-200 ease-premium hover:border-metal lg:py-11" data-id="element-383" data-mp="1doiuupujdzw2">
                <dd className="font-serif text-[40px] font-semibold leading-none tracking-[-0.02em] text-navy lg:text-5xl" data-id="element-384" data-mp="1nn8cqimfnkcb">
                  <Counter value={metric.value} prefix={metric.prefix} suffix={metric.suffix} decimals={metric.decimals} data-id="element-385" data-mp="3uer3u8bwimj2" />
                </dd>
                <dt className="mt-3 max-w-[17ch] text-[13px] font-medium leading-snug text-charcoal-muted transition-colors duration-200 ease-premium group-hover:text-charcoal" data-id="element-386" data-mp="29yojmylm3zlf">
                  {metric.label}
                </dt>
              </div>
            </Reveal>)}
        </dl>

        <Reveal data-id="element-387" data-mp="2jqck1p05cqz1">
          <dl className="grid grid-cols-1 gap-x-8 gap-y-4 border-t border-line py-7 sm:grid-cols-2 lg:grid-cols-4" data-id="element-388" data-mp="2onuqn8qoyu3v">
            {secondaryMetrics.map(metric => <div key={metric.label} className="flex items-baseline gap-3" data-id="element-389" data-mp="2tos81j3vnk4b">
                <dd className="font-serif text-[17px] font-semibold text-navy" data-id="element-390" data-mp="2xoso186mk3dh">{metric.value}</dd>
                <dt className="text-[13px] leading-snug text-charcoal-muted" data-id="element-391" data-mp="32mu5xpsbdwnd">{metric.label}</dt>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </section>;
}